import { Link } from "react-router-dom";
import { ExternalLink, ArrowRight } from "lucide-react";

const newsItems = [
  {
    title: "AMX Ventures-Backed Arun Mohan Joins Actualize to Lead Growth of Arabic Voice AI",
    source: "Entrepreneur Middle East",
    url: "https://www.entrepreneur.com/en-ae/starting-a-business/amx-ventures-backed-arun-mohan-joins-actualize-to/501270",
  },
  {
    title: "Actualize Picks Arun Mohan as Equity Partner as It Scales Arabic Voice Intelligence Stack",
    source: "Campaign Middle East",
    url: "https://campaignme.com/actualize-picks-arun-mohan-as-equity-partner-as-it-scales-arabic-voice-intelligence-stack/",
  }
];

const NewsSection = () => {
  return (
    <section id="news" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground">
            In the News
          </h2>
          <Link 
            to="/news" 
            className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
          >
            View all <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="space-y-4">
          {newsItems.map((item, index) => (
            <a
              key={index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block group"
            >
              <article className="p-5 rounded-xl border border-border bg-card hover:border-primary/50 transition-all duration-300 hover:shadow-lg">
                <div className="flex items-center justify-between gap-4">
                  <div className="flex-1">
                    <span className="text-sm font-medium text-primary mb-1 block">
                      {item.source}
                    </span>
                    <h3 className="text-lg font-semibold text-foreground group-hover:text-primary transition-colors">
                      {item.title}
                    </h3>
                  </div>
                  <ExternalLink className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
                </div>
              </article>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
